import { Price, Text } from '@kanda-libs/ks-design-library';

import GridComponent from './GridComponent';
import useFinanceInfo from './useFinanceInfo';

import { CheckoutFinanceRate } from '../constants';

interface FinanceInfoProps {
  isLoading: boolean;
  selectedRate?: CheckoutFinanceRate;
}

const FinanceInfo = ({ isLoading, selectedRate }: FinanceInfoProps) => {
  const { info } = useFinanceInfo(selectedRate);

  return (
    <div className="p-4 mb-6 bg-purple-50 border border-purple-200 rounded-xl md:mt-2">
      <div className="grid grid-cols-3 gap-4">
        {info.isBuyNowPayLater && (
          <GridComponent
            title="interest rate"
            isLoading={isLoading}
            component={
              <Text
                text={`${info.interestRate / 100}%`}
                className="mt-px text-16-20-em text-neutral-700"
              />
            }
          />
        )}
        {info.isBuyNowPayLater && (
          <GridComponent
            title="Deferred term"
            isLoading={isLoading}
            component={
              <Text
                text={`${info.deferredDuration} months`}
                className="mt-px text-16-20-em text-neutral-700"
              />
            }
          />
        )}
        {info.isBuyNowPayLater && (
          <GridComponent
            title=""
            isLoading={isLoading}
            component={
              <Text text="" className="mt-px text-16-20-em text-neutral-700" />
            }
          />
        )}
        <GridComponent
          title="job price"
          isLoading={isLoading}
          component={
            <Price
              amount={info.jobTotal}
              isLoading={isLoading}
              poundsClassName="text-16-20-em text-neutral-700"
              centsClassName="text-10-14-em mt-px text-neutral-700"
            />
          }
        />
        <GridComponent
          title="deposit"
          className="lg:order-2"
          isLoading={isLoading}
          labelColor="text-neutral-600"
          component={
            <Price
              amount={info.deposit}
              isLoading={isLoading}
              poundsClassName="text-16-20-em text-neutral-700"
              centsClassName="text-10-14-em mt-px text-neutral-700"
            />
          }
        />
        <GridComponent
          title="monthly cost"
          isLoading={isLoading}
          component={
            <Price
              amount={info.monthly}
              isLoading={isLoading}
              poundsClassName="text-16-20-em text-neutral-700"
              centsClassName="text-10-14-em mt-px text-neutral-700"
            />
          }
        />
        <GridComponent
          title={info.isBuyNowPayLater ? 'APR terms' : 'terms'}
          className="lg:order-3"
          isLoading={isLoading}
          component={
            <Text
              text={`${info.term} months`}
              isLoading={isLoading}
              className="text-16-20-em text-neutral-700"
            />
          }
        />
        <GridComponent
          title="interest fee"
          className="lg:order-4"
          isLoading={isLoading}
          component={
            <Price
              amount={info.interest}
              isLoading={isLoading}
              poundsClassName="text-16-20-em text-neutral-700"
              centsClassName="text-10-14-em mt-px text-neutral-700"
            />
          }
        />
        <GridComponent
          title="total cost"
          className="lg:order-5"
          isLoading={isLoading}
          component={
            <Price
              amount={info.total}
              isLoading={isLoading}
              poundsClassName="text-16-20-em text-neutral-700"
              centsClassName="text-10-14-em mt-px text-neutral-700"
            />
          }
        />
      </div>
    </div>
  );
};

export default FinanceInfo;
